import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios"; //引入axios
import 'lib-flexible/flexible.js'//引入屏幕适配 可用rem
import model from "./vue/store/model"; //保存全局变量文件
import { showNotify, Button, Form, Field, CellGroup, Notify } from "vant";
// createApp(App).use(store).use(Button).use(router).mount("#app");

import 'vant/lib/index.css';
// 创建 axios 实例
const service = axios.create({
  baseURL: "/", //process.env.VUE_APP_BASE_URL, //
  timeout: 100000, // 请求超时时间
});

const app = createApp(App);

app.config.globalProperties.axios = service;
app.config.globalProperties.model = model;
app.config.globalProperties.showNotify = showNotify;

app.use(router);
app.use(store);
app.use(Button);
app.use(Form);
app.use(Field);
app.use(CellGroup);
app.use(Notify);

app.mount("#app");
